import moment from "moment"
const mutations = {
	setUser(state, user) {
		localStorage.setItem("user", JSON.stringify(user))
		state.user = user;
	},
	clearUser(state) {
		localStorage.removeItem("user")
		state.user = null;
	},
	getUser(state) {
		var user = localStorage.getItem("user");
		if (user != null) {
			user = JSON.parse(user);
			if(moment(user.expireTime).valueOf() < moment().valueOf()){
				state.user = null;
				this.commit("clearUser");
			}else{
				state.user = user;
			}
		}
	},
	openInvitationVisible(state){
		state.invitationVisible = true;
	},
	closeInvitationVisible(state){
		state.invitationVisible = false;
	},


}

export default mutations
